import {useEffect, useMemo} from "react";
import './index.css';
import {mediaMatch} from "../../utils";

export default function Switch(props) {
  const { checked, loading, disabled = false, onChange, size } = props;
  const isMdMax = mediaMatch.isMdmax;
  
  let _disable = useMemo(() => {
    return disabled || loading || false;
  }, [loading, disabled]);
  
  let _size = useMemo(() => {
    if (size) return size;
    return isMdMax ? 'small' : 'mid';
  }, [size]);
  
  const clickHandle = () => {
    if (_disable) return;
    if (onChange) {
      onChange(!checked);
    }
  };
  
  return (
    <div className={`__switch ${_size} ${checked ? 'checked' : 'check'}`}
         onClick={clickHandle}
         style={{ opacity: _disable ? 0.5 : 1 }}>
    </div>
  );
}
